import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon from '@/src/components/common/Elements/Icon/Icon';
import { cn } from '@/src/util/ui';

type TooltipProps = {
  content: string;
  place?: string;
  className?: string;
};

type ActionButtonProps = {
  id?;
  className?: string;
  iconClasses?: string;
  icon;
  iconType?;
  label?: string;
  tooltipSettings?: TooltipProps;
  onClick: (...args: any[]) => any;
  disabled?: boolean;
};

const ActionButton = ({
  id,
  className,
  iconClasses,
  icon,
  iconType,
  label,
  tooltipSettings,
  onClick,
  disabled = false,
}: ActionButtonProps) => {
  return (
    <Button
      id={id}
      className={cn(
        'hover:tw-text-cfo-blue-700 hover:tw-bg-cfo-blue-200',
        label ? 'tw-rounded-none tw-mr-0 tw-p-[10px]' : 'tw-rounded-[50px] tw-mr-0 tw-p-[3px]',
        className
      )}
      tooltip={tooltipSettings}
      onClick={onClick}
      disabled={disabled}
    >
      {label && <span className={clsx('group-hover:tw-font-brandonTextMedium')}>{label}</span>}

      <Icon
        className={cn('tw-text-[22px]', 'group-hover:tw-text-cfo-blue-700', iconClasses)}
        icon={icon}
        iconType={iconType}
      />
    </Button>
  );
};

export default ActionButton;
